var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"menu-form"},[_c('Header'),_c('Merchant'),_c('section',{staticClass:"main"},[_c('ChooseAmount'),_c('ReceiptSend'),_c('PayMethods')],1),_c('Footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }